/**
 * @fileoverview gRPC-Web generated client stub for authDashboardTask
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v3.20.3
// source: api/soter-task/dashboard/v1/auth_service.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var api_soter$task_common_v1_auth_message_pb = require('../../../../api/soter-task/common/v1/auth_message_pb.js')
const proto = {};
proto.authDashboardTask = require('./auth_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.authDashboardTask.TaskDashboardAuthServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.authDashboardTask.TaskDashboardAuthServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authTask.CheckEmailDashboardUserRequest,
 *   !proto.authTask.CheckEmailResponse>}
 */
const methodDescriptor_TaskDashboardAuthService_CheckEmail = new grpc.web.MethodDescriptor(
  '/authDashboardTask.TaskDashboardAuthService/CheckEmail',
  grpc.web.MethodType.UNARY,
  api_soter$task_common_v1_auth_message_pb.CheckEmailDashboardUserRequest,
  api_soter$task_common_v1_auth_message_pb.CheckEmailResponse,
  /**
   * @param {!proto.authTask.CheckEmailDashboardUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  api_soter$task_common_v1_auth_message_pb.CheckEmailResponse.deserializeBinary
);


/**
 * @param {!proto.authTask.CheckEmailDashboardUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authTask.CheckEmailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authTask.CheckEmailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authDashboardTask.TaskDashboardAuthServiceClient.prototype.checkEmail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authDashboardTask.TaskDashboardAuthService/CheckEmail',
      request,
      metadata || {},
      methodDescriptor_TaskDashboardAuthService_CheckEmail,
      callback);
};


/**
 * @param {!proto.authTask.CheckEmailDashboardUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authTask.CheckEmailResponse>}
 *     Promise that resolves to the response
 */
proto.authDashboardTask.TaskDashboardAuthServicePromiseClient.prototype.checkEmail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authDashboardTask.TaskDashboardAuthService/CheckEmail',
      request,
      metadata || {},
      methodDescriptor_TaskDashboardAuthService_CheckEmail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authTask.ConfirmEmailRequest,
 *   !proto.authTask.LoginTaskResponse>}
 */
const methodDescriptor_TaskDashboardAuthService_ConfirmEmail = new grpc.web.MethodDescriptor(
  '/authDashboardTask.TaskDashboardAuthService/ConfirmEmail',
  grpc.web.MethodType.UNARY,
  api_soter$task_common_v1_auth_message_pb.ConfirmEmailRequest,
  api_soter$task_common_v1_auth_message_pb.LoginTaskResponse,
  /**
   * @param {!proto.authTask.ConfirmEmailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  api_soter$task_common_v1_auth_message_pb.LoginTaskResponse.deserializeBinary
);


/**
 * @param {!proto.authTask.ConfirmEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authTask.LoginTaskResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authTask.LoginTaskResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authDashboardTask.TaskDashboardAuthServiceClient.prototype.confirmEmail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authDashboardTask.TaskDashboardAuthService/ConfirmEmail',
      request,
      metadata || {},
      methodDescriptor_TaskDashboardAuthService_ConfirmEmail,
      callback);
};


/**
 * @param {!proto.authTask.ConfirmEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authTask.LoginTaskResponse>}
 *     Promise that resolves to the response
 */
proto.authDashboardTask.TaskDashboardAuthServicePromiseClient.prototype.confirmEmail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authDashboardTask.TaskDashboardAuthService/ConfirmEmail',
      request,
      metadata || {},
      methodDescriptor_TaskDashboardAuthService_ConfirmEmail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authTask.ResendConfirmationRequest,
 *   !proto.authTask.ResendConfirmationResponse>}
 */
const methodDescriptor_TaskDashboardAuthService_ResendConfirmationEmail = new grpc.web.MethodDescriptor(
  '/authDashboardTask.TaskDashboardAuthService/ResendConfirmationEmail',
  grpc.web.MethodType.UNARY,
  api_soter$task_common_v1_auth_message_pb.ResendConfirmationRequest,
  api_soter$task_common_v1_auth_message_pb.ResendConfirmationResponse,
  /**
   * @param {!proto.authTask.ResendConfirmationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  api_soter$task_common_v1_auth_message_pb.ResendConfirmationResponse.deserializeBinary
);


/**
 * @param {!proto.authTask.ResendConfirmationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authTask.ResendConfirmationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authTask.ResendConfirmationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authDashboardTask.TaskDashboardAuthServiceClient.prototype.resendConfirmationEmail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authDashboardTask.TaskDashboardAuthService/ResendConfirmationEmail',
      request,
      metadata || {},
      methodDescriptor_TaskDashboardAuthService_ResendConfirmationEmail,
      callback);
};


/**
 * @param {!proto.authTask.ResendConfirmationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authTask.ResendConfirmationResponse>}
 *     Promise that resolves to the response
 */
proto.authDashboardTask.TaskDashboardAuthServicePromiseClient.prototype.resendConfirmationEmail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authDashboardTask.TaskDashboardAuthService/ResendConfirmationEmail',
      request,
      metadata || {},
      methodDescriptor_TaskDashboardAuthService_ResendConfirmationEmail);
};


module.exports = proto.authDashboardTask;

